module.exports = __webpack_public_path__ + "static/media/difficulty-meter.965ac0b5.svg";